var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.21144 8.86501H11.1516V21.1459C11.1516 21.3724 11.2415 21.5897 11.4017 21.7498C11.5619 21.91 11.7791 22 12.0056 22C12.2321 22 12.4494 21.91 12.6096 21.7498C12.7697 21.5897 12.8597 21.3724 12.8597 21.1459V8.86501H16.7884C16.8959 8.86628 17.0012 8.83517 17.0908 8.77573C17.1803 8.7163 17.2499 8.63129 17.2904 8.53177C17.3309 8.43225 17.3406 8.32283 17.3181 8.21775C17.2956 8.11267 17.242 8.0168 17.1642 7.94262L12.3814 2.15981C12.3316 2.1092 12.2722 2.06901 12.2067 2.04157C12.1412 2.01413 12.0709 2 11.9999 2C11.9289 2 11.8586 2.01413 11.7931 2.04157C11.7276 2.06901 11.6683 2.1092 11.6185 2.15981L6.83565 7.94262C6.75791 8.0168 6.70429 8.11267 6.68179 8.21775C6.65929 8.32283 6.66893 8.43225 6.70948 8.53177C6.75002 8.63129 6.81959 8.7163 6.90911 8.77573C6.99864 8.83517 7.10399 8.86628 7.21144 8.86501Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackUp);
export default __webpack_public_path__ + "static/media/black-up.b1b1aaacc552921718442cc0804a0ae4.svg";
export { ForwardRef as ReactComponent };